import Vue from 'vue'
import {
  Pagination,
  Button,
  Input,
  Radio,
  Form,
  FormModel,
  Icon,
  Checkbox,
  AutoComplete,
  Select,
  notification,
  message,
  Layout,
  Menu,
  Dropdown,
  Avatar,
  PageHeader,
  Card,
  Modal,
  Row,
  Col,
  DatePicker,
  Descriptions,
  Skeleton,
  Tooltip,
  Popover,
  Table,
  ConfigProvider,
  Divider,
  Badge,
  Tag,
  Upload,
  List,
  Popconfirm,
  Empty,
  Tree,
  BackTop,
  Steps,
  Cascader,
  Transfer,
  Collapse,
  InputNumber,
  Result,
  Tabs,
  Anchor,
  Affix,
  Drawer,
  Spin,
} from 'ant-design-vue'

Vue.use(Input)
Vue.use(Button)
Vue.use(Radio)
Vue.use(Pagination)
Vue.use(Form)
Vue.use(FormModel)
Vue.use(Icon)
Vue.use(Checkbox)
Vue.use(AutoComplete)
Vue.use(Select)
Vue.use(Layout)
Vue.use(Menu)
Vue.use(Dropdown)
Vue.use(Avatar)
Vue.use(PageHeader)
Vue.use(Card)
Vue.use(Row)
Vue.use(Col)
Vue.use(Descriptions)
Vue.use(Skeleton)
Vue.use(Tooltip)
Vue.use(Popover)
Vue.use(Table)
Vue.use(Modal)
Vue.use(Row)
Vue.use(Col)
Vue.use(DatePicker)
Vue.use(ConfigProvider)
Vue.use(Divider)
Vue.use(Badge)
Vue.use(Upload)
Vue.use(Popconfirm)
Vue.use(Tree)
Vue.use(List)
Vue.use(Tag)
Vue.use(Empty)
Vue.use(BackTop)
Vue.use(Steps)
Vue.use(Cascader)
Vue.use(Transfer)
Vue.use(Collapse)
Vue.use(InputNumber)
Vue.use(Result)
Vue.use(Tabs)
Vue.use(Anchor)
Vue.use(Affix)
Vue.use(Drawer)
Vue.use(Spin)

Vue.prototype.$notification = notification
Vue.prototype.$message = message

Vue.prototype.$confirm = Modal.confirm
Vue.prototype.$warning = Modal.warning
